import { render, staticRenderFns } from "./CardReaderBox.vue?vue&type=template&id=1d608206&scoped=true"
import script from "./CardReaderBox.vue?vue&type=script&lang=js"
export * from "./CardReaderBox.vue?vue&type=script&lang=js"
import style0 from "./CardReaderBox.vue?vue&type=style&index=0&id=1d608206&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d608206",
  null
  
)

export default component.exports